import * as _ from "lodash";
import {AnyAction} from "redux";
import {createSelector} from "reselect";
import {countPowerSources, getPopulatedPowerSources} from "../powerSources";
import {IPowerSource, IYear} from "../../../data/data";
import {getYearData} from '../year';


// /**
//  * get the ideal amount of env. impact
//  * @returns {number}
//  */
// export function getTargetCarbonOutput() : number
// {
//     const locations: IPowerSourceLocation[] = getPowerSourceLocationsData();
//     const power_sources: IPowerSource[] = getPowerSourcesData();
//     const ratios: IEnergyMixDictionary = getEnergyMixData();
//
//     const impact_sum: number = _.reduce(power_sources, (sum: number, power_source: IPowerSource) =>
//     {
//         return sum + (ratios[power_source.id] * 0.01 * locations.length) * power_source['carbon-output'];
//     }, 0)
//
//     return impact_sum;
// }


//  define selectors

/**
 * get the total env. impact of all power sources
 */
export const getCarbonOutput = createSelector(

    [getPopulatedPowerSources],

    (power_sources: IPowerSource[]) =>
    {
        if (! power_sources.length) return 0;

        return _.sumBy(power_sources, 'carbon-output');
    }
);


/**
 * get the total percentage of power generated by low-carbon sources
 */
export const getCarbonOutputPercentage = createSelector(

    [getCarbonOutput, countPowerSources],

    (carbon_output: number, power_source_count: number) =>
    {
        if (! carbon_output || ! power_source_count) return 0;

        return Math.round(100 - (carbon_output / power_source_count / 0.01));
    }
);


/**
 * get the total env. impact of all power sources
 */
export const getCarbonOutputTarget = createSelector(

    [getYearData],

    (year_data: IYear) : number =>
    {
        if (! year_data) return 8.5;

        return year_data['carbon-target'];
    }
);


// /**
//  * get the total env. impact of all power sources
//  */
// export const getCarbonOutputRatio = createSelector(
//
//     [getCarbonOutput, getCarbonOutputTarget],
//
//     (output: number, target: number) : number =>
//     {
//         if (! output || ! target) return 0;
//
//         const ratio: number = _.clamp(actual / (target * 2), 0, 1);
//
//         // console.group('getCarbonOutputRatio');
//         // console.log('actual', actual);
//         // console.log('target', target);
//         // console.log('ratio', ratio);
//         // console.groupEnd();
//
//         return parseFloat(ratio.toFixed(2));
//     }
// );


//  define the initial state

const initialState: number = 0;


// /**
//  * reducer: set the current environmental-friendliness
//  * @param {number} state
//  * @param {AnyAction} action
//  * @returns {number}
//  */
// export function carbonOutput(state: number = initialState, action: AnyAction) : number
// {
//     switch (action.type)
//     {
//         default:
//
//             return state;
//     }
// }



// WEBPACK FOOTER //
// ./src/ts/store/reducers/outputs/carbonOutput.ts